import Settings from '../olr-common/Settings';
import R from 'ramda';

export default function HomeworkController($location,$state, Upload, $window, $http, $scope, $mdToast, HomeworkService, localStorageService) {
	var self = this;
    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.listItems = loadClassRooms();
    self.selectedItemsForEmail = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;
    $scope.showSelectClassError = false;

    self.uploadContent = {'subject': '', 'message': ''};

    var showToast = function(){
        $mdToast.show(
          $mdToast.simple()
            .textContent('Homework Posted Successfully')
            .position('top right')
            .hideDelay(3000)
        );
    };

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }
    }

    function querySearch (query) {
      $scope.showSelectClassError = false;
      var results = query ? self.listItems.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(loadingItem) {
        return (loadingItem._lowerClassName.indexOf(lowercaseQuery) === 0) ||
            (loadingItem._lowerSubject.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadClassRooms() {
      var classRooms = localStorageService.get('classrooms');

      if(classRooms){
        return classRooms.map(function (loadItem) {
            loadItem._lowerClassName = loadItem.classRoomName.toLowerCase();
            loadItem._lowerSubject = loadItem.subjectName.toLowerCase();
            return loadItem;
        });
      } 
    }

    $scope.sendUpload = function(){
        if(self.selectedItemsForEmail.length === 0){
            $scope.showSelectClassError = true;
            return;
        }

        if(self.hwForm.$invalid){
        angular.forEach(self.hwForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }
        var reqObj = {'selectedClasses': [], 'subject': self.uploadContent.subject, 'message': self.uploadContent.message};
        var fileExist = false;
        var fileName = '';
        if(self.upload_form.file.$valid && self.file){
            fileExist = true;
            fileName = self.file.name;
        }
        reqObj.fileExist = fileExist;
        reqObj.fileName = fileName;

        for(var i=0;i<self.selectedItemsForEmail.length;i++){
            reqObj.selectedClasses.push({'classRoomId': self.selectedItemsForEmail[i].classRoomId, 'subjectId': self.selectedItemsForEmail[i].subjectId});
        }
        
        HomeworkService.saveHW(reqObj).then(function(resp){
            if(fileExist){
                Upload.upload({
                    url: Settings.backendEnv + '/api/v1/upload',
                    headers: {
                       'filetoken': resp.data.hwId
                     },
                    data:{file:self.file} //pass file as data, should be user ng-model
                }).then(function (resp) { //upload function returns a promise
                    if(resp.data.error_code === 0){ //validate success
                        showToast();
                        //$window.alert('Success ' + resp.config.data.file.name + 'uploaded. Response: ');
                    } else {
                        //$window.alert('an error occured');
                    }
                }, function (resp) { //catch error
                    console.log('Error status: ' + resp.status);
                    //$window.alert('Error status: ' + resp.status);
                }, function (evt) { 
                    console.log(evt);
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    self.progress = 'progress: ' + progressPercentage + '% '; // capture upload progress
                });
            }
            else{
                showToast();
            }
        });
    }


    // $http({method:'GET', url:'http://localhost:8080/download', responseType: "blob"}).
    //    then(function(resp) { 
    //    console.log(data);        
    //      var data = resp.data,
    //         blob = new Blob([data], { type: 'image/png' }),
    //         url = $window.URL || $window.webkitURL;
    //         $scope.fileUrl = url.createObjectURL(blob);
    //     });

    // self.download = function(){
        
    // }
    
          
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-homework/HomeworkController.js
 **/